const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class Patriotism extends Action {
    constructor(age){
        super(
            age,
            ActionNames.Patriotism, 
            `For this turn, you have an extra ${Patriotism.GetResourceAmount(age)} resource for building and upgrading military units and 1 extra military action.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 1;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
            case Age.Age3:
                return 4;
        }
    }
}

module.exports = Patriotism;
